import { render, staticRenderFns } from "./Licenses.vue?vue&type=template&id=00c74ba6&scoped=true"
import script from "./Licenses.vue?vue&type=script&lang=js"
export * from "./Licenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c74ba6",
  null
  
)

export default component.exports